import React, { useEffect, useRef } from "react";
import style from "./Style.module.css";
import "./sheetCard.css";
import Pattern1 from "./Pattern/Pattern1";
import Pattern2 from "./Pattern/Pattern2";
import Pattern3 from "./Pattern/Pattern3";
import Pattern4 from "./Pattern/Pattern4";
import Pattern5 from "./Pattern/Pattern5";
import Pattern6 from "./Pattern/Pattern6";
import Pattern7 from "./Pattern/Pattern7";
import Pattern8 from "./Pattern/Pattern8";
import Suggested from "../../asset/suggestedSheet.svg";
import { ReactComponent as SteamIcon } from "../../asset/steamIcon.svg";
import { Tooltip } from "antd";
import Util from "../../Util";

const patternComponents = [
  Pattern1,
  Pattern2,
  Pattern3,
  Pattern4,
  Pattern5,
  Pattern6,
  Pattern7,
  Pattern8,
];

const MySheet = (props) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [shouldScroll, setShouldScroll] = React.useState(false);
  const [name, setName] = React.useState();
  const [code, setCode] = React.useState();
  const bgColor = props?.color ?? "#B2BB1F";
  const [isLight, setIsLight] = React.useState(false);
  const [fontColor, setFontColor] = React.useState("ffffff");
  const Pattern =
    patternComponents[(props?.index ?? 0) % patternComponents.length];
  const isSuggested = props.sheet?.highlighted;

  const type = [
    "ทั้งเทอม",
    "มิดเทอม",
    "ไฟนอล",
    "สอบในห้อง",
    "อ่านเข้ามหาวิทยาลัย",
    "อ่านเข้า ม.4",
  ];

  useEffect(() => {
    if (props?.color) {
      const isLight = Util.checkColorLight(props.color);

      setIsLight(isLight);
      setFontColor(isLight ? "#000000" : "#ffffff");
    }
  }, [props?.color]);

  useEffect(() => {
    splitTitle(props?.sheet?.name);
  }, [props?.sheet?.name]);

  useEffect(() => {
    if (code) {
      const container = containerRef.current;
      const textEl = textRef.current;

      if (container && textEl) {
        setShouldScroll(textEl.scrollWidth > container.clientWidth);
      }
    }
  }, [code]);

  const splitTitle = (title) => {
    const parts = title.trim().split(" ");
    const code = parts[0];
    const name = parts.slice(1).join(" ");
    setCode(code);
    setName(name);
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} | ${hours}:${minutes}`;
  };

  const renderOnlineTutor = () => {
    if (!props.sheet?.onlineTutor) {
      return null;
    }

    if (props.sheet?.onlineTutor?.isLiveSteamEnded) {
      return (
        <div className={style.tagSteamEnded}>
          <SteamIcon />
          <span>ชีทพร้อมคลิปติวย้อนหลัง</span>
        </div>
      );
    }

    return (
      <div className={style.tagTutoring}>
        <Tooltip title="ติวออนไลน์">
          <div className={style.blackGradientTag}>ติวออนไลน์</div>
        </Tooltip>

        <p style={{ margin: 0 }} className={style.timeTutoring}>
          <Tooltip title={formatTimestamp(props.sheet?.onlineTutor?.startDate)}>
            {formatTimestamp(props.sheet?.onlineTutor?.startDate)}
          </Tooltip>
        </p>
      </div>
    );
  };

  return (
    <div
      className={[style.cardContainer].join(" ")}
      onClick={() => {
        if (props.callbackClick) {
          props.callbackClick();
        } else {
          window.open(`/infoSheet/${props.sheet._id}`, "_blank");
        }
      }}
    >
      {isSuggested ? (
        <div className={style.suggestedLabel}>
          <img src={Suggested} alt="suggested" /> <b>ชีทแนะนำ!</b>
        </div>
      ) : null}
      <div
        className={[isSuggested ? style.suggested : {}].join(" ")}
        style={{
          backgroundColor: bgColor,
          borderRadius: 12,
        }}
      >
        <div
          className={style.boughtCardContent}
          style={{
            width: props.size ?? "240px",
            backgroundColor: bgColor,
            margin: "0 auto",
          }}
        >
          <Pattern
            color={isLight ? "#2F2F2F" : "#ffffff"}
            className={style.svgBackground}
          />
          <div className={style.contentContainer}>
            <div>
              <div className={style.topLabel} style={{ color: fontColor }}>
                <p>
                  {props?.sheet?.category !== undefined
                    ? type[props?.sheet?.category] + " | "
                    : "-"}
                  {props?.sheet?.semester !== undefined &&
                  props?.sheet?.year !== undefined ? (
                    <>
                      เทอม {props?.sheet?.semester}/{props?.sheet?.year}
                    </>
                  ) : null}
                </p>
              </div>

              <div ref={containerRef}>
                {code ? (
                  <h1
                    ref={textRef}
                    style={{
                      color: fontColor,
                      fontWeight: 400,
                      "--marquee-speed": `${50}px`,
                    }}
                    className={` marquee-text ${shouldScroll ? "scroll" : ""}`}
                  >
                    {code}
                  </h1>
                ) : (
                  <h1
                    ref={textRef}
                    style={{
                      fontWeight: 400,
                      "--marquee-speed": `${50}px`,
                      color: isLight ? fontColor : "rgba(255, 255, 255, 0.30);",
                    }}
                    className={` marquee-text ${shouldScroll ? "scroll" : ""}`}
                  >
                    รหัสยังไม่ถูกระบุ
                  </h1>
                )}

                {name ? (
                  <Tooltip title={name}>
                    <h4 className={style.nameText} style={{ color: fontColor }}>
                      {name}
                    </h4>
                  </Tooltip>
                ) : (
                  <h4
                    className={style.nameTextOpacity}
                    style={{
                      color: fontColor,
                    }}
                  >
                    (ชื่อรายวิชายังไม่ถูกระบุ)
                  </h4>
                )}
              </div>
            </div>

            <div className={style.bottomLabel}>
              {renderOnlineTutor()}
              {/* {props.sheet?.onlineTutor ? (
                <div className={style.tagTutoring}>
                  <Tooltip title="ติวออนไลน์">
                    <div className={style.blackGradientTag}>ติวออนไลน์</div>
                  </Tooltip>

                  <p style={{ margin: 0 }} className={style.timeTutoring}>
                    <Tooltip
                      title={formatTimestamp(
                        props.sheet?.onlineTutor?.startDate
                      )}
                    >
                      {formatTimestamp(props.sheet?.onlineTutor?.startDate)}
                    </Tooltip>
                  </p>
                </div>
              ) : null} */}
              <div className={style.authorSection} style={{ color: fontColor }}>
                {props?.sheet?.authorCode ?? "-"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MySheet;
